var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FileUploadSection } from "@frameworks/shared-library/components/fileupload/fileUploadSection";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import di from "../../di/serviceLocator";
import { emailRegex, phoneNo } from "@frameworks/web/utils/regex";
import { detectMimeType, } from "@frameworks/salesjourney/utils/genericMethods";
import { pan } from "@frameworks/web/utils/regex";
export var PoaFormPop = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var initialPoa = {
        acCode: "",
        thirdParty_Name: "",
        relation: "",
        comments: "",
        panNo: "",
        email: "",
        fileName: "",
        data: "",
        acName: "",
        eqbse: "False",
        eqnse: "False",
        eqmsei: "False",
        fobse: "False",
        fonse: "False",
        fomsei: "False",
        currencybse: "False",
        currencynse: "False",
        currencymsei: "False",
        mcx: "False",
        ncdex: "False",
        neml: "False",
        mobileNo: "",
        poaFiles: "",
    };
    var _k = __read(React.useState(), 2), poaFormData = _k[0], setPoaFormData = _k[1];
    var _l = __read(React.useState(false), 2), loader = _l[0], setLoader = _l[1];
    var _m = __read(React.useState(false), 2), disable = _m[0], setDisable = _m[1];
    var _o = __read(React.useState(initialPoa), 2), formData = _o[0], setFormData = _o[1];
    var _p = __read(useState(null), 2), error = _p[0], setError = _p[1];
    var _q = __read(useState(""), 2), deleteMsg = _q[0], setDeleteMsg = _q[1];
    var _r = __read(useState(""), 2), saveSuceMsg = _r[0], setSaveSuceMsg = _r[1];
    var _s = __read(useState(false), 2), saveThirdPartyError = _s[0], setSaveThirdPartyError = _s[1];
    var _t = __read(React.useState(false), 2), editData = _t[0], setEditData = _t[1];
    var getThirdPartyPOAData = function (accCode) {
        di.clients
            .getThirdPartyPOAData(accCode)
            .then(function (resp) {
            setEditData(true);
            setFormData(resp);
            setError({
                email: "",
                mobileNo: "",
                panno: "",
                thirdParty_NAME: "",
            });
        })
            .catch(function (error) {
            setEditData(false);
            setError(null);
            setFormData(initialPoa);
        });
    };
    function getThirdPartyPOA(accountCode) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        getThirdPartyPOAData(accountCode);
                        return [4 /*yield*/, di.clients
                                .getThirdPartyPOADetailsData({
                                acCode: accountCode,
                            })
                                .then(function (getThirdpartydata) {
                                setLoader(false);
                                setPoaFormData(getThirdpartydata);
                            })
                                .catch(function (error) {
                                setLoader(false);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var _u = __read(useState(false), 2), resetFileUpload = _u[0], setResetFileUpload = _u[1];
    React.useEffect(function () {
        if (props.accountCode) {
            setLoader(true);
            getThirdPartyPOA(props.accountCode);
        }
    }, [props.accountCode]);
    var handleChange = function (name, value) {
        setFormData(function (form) {
            var _a;
            return __assign(__assign({}, form), (_a = {}, _a[name] = value, _a));
        });
    };
    var saveThirdPartyPOADetails = function () {
        if (!!formData.acCode) {
            formData.acCode = props.accountCode;
        }
        if (!!formData.acName) {
            formData.acName = poaFormData.acName;
        }
        if (!!formData.fileName && !!formData.poaFiles)
            confirm("Do you want to SAVE without uploading a the scanned POA?");
        di.clients
            .saveThirdPartyPOA(formData)
            .then(function (resp) {
            if (resp.strMsg === "1045") {
                setSaveSuceMsg("Data empty. Please fill all fields.");
                setSaveThirdPartyError(true);
            }
            else {
                setSaveSuceMsg("Third Party POA Details Saved Successfully.");
                setSaveThirdPartyError(false);
            }
            //props.setPoaForm(false)
        })
            .catch(function (error) {
            setSaveSuceMsg("Something is wrong. please try some time later");
            setSaveThirdPartyError(true);
        });
    };
    var handleError = function (field, value) {
        setError(function (err) {
            var _a;
            return __assign(__assign({}, err), (_a = {}, _a[field] = value, _a));
        });
    };
    // const handleFileUpload = (fileDetails: ) => {
    //   if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
    //     setFormData({
    //       ...formData,
    //       fileName: fileDetails.docFile,
    //       poaFiles: fileDetails.base64Data.split(",")[1],
    //     });
    //   }
    // };
    var constructErrorChild = function (message) {
        return (React.createElement("div", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, message));
    };
    var fileSizeHelper = function (fileInfo, msg) {
        props.setpoaFileUploadError(true);
        props.setpoaUploadErrorChild(constructErrorChild(msg));
        setResetFileUpload(true);
        setFormData(__assign(__assign({}, formData), { poaFiles: null }));
        return true;
    };
    var fileSizeError = function (fileInfo) {
        if (fileInfo.fileSize > 8388608)
            return fileSizeHelper(fileInfo, "The File size approximately less than 8MB");
        return false;
    };
    var handleFileUpload = function (fileDetails) {
        var fileInfo = {
            fileContent: "",
            fileName: "",
            fileSize: 0,
        };
        if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
            fileInfo = {
                fileContent: fileDetails.base64Data.split(",")[1],
                fileName: fileDetails.docFile,
                fileSize: fileDetails.docFileSize,
            };
            if (fileSizeError(fileInfo)) {
                setResetFileUpload(false);
                return;
            }
            setFormData(__assign(__assign({}, formData), { poaFiles: fileInfo.fileContent }));
        }
        else
            setFormData(__assign(__assign({}, formData), { poaFiles: null }));
    };
    React.useEffect(function () {
        if (!!error) {
            if (error.panno === "" &&
                error.email === "" &&
                error.mobileNo === "" &&
                error.thirdParty_NAME === "") {
                setDisable(false);
            }
            else {
                setDisable(true);
            }
        }
        else {
            setDisable(true);
        }
    }, [error]);
    var downloadsClients = function (base64String) {
        if (editData && formData.fileName && formData.poaFiles) {
            var decodedPdfContents = window.atob(formData.poaFiles);
            var byteArrays = new Uint8Array(decodedPdfContents.length);
            for (var i = 0; i < decodedPdfContents.length; i++) {
                byteArrays[i] = decodedPdfContents.charCodeAt(i);
            }
            var blobs = new Blob([byteArrays.buffer], {
                type: detectMimeType(formData.poaFiles),
            });
            var _pdfurls = URL.createObjectURL(blobs);
            var links = document.createElement("a");
            document.body.appendChild(links);
            links.href = _pdfurls;
            links.download = formData.fileName;
            var evts = new MouseEvent("click", {
                view: window,
                bubbles: true,
                cancelable: false,
            });
            links.dispatchEvent(evts);
            window.URL.revokeObjectURL(_pdfurls);
            links.remove();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "px-0 mx-0 dpledger-block" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: "px-0 HeadRow" },
                    React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left", onClick: function () {
                                props.setpaymentlinkshow(false);
                            } }),
                        React.createElement("span", { className: "EncodeSans_20_700" },
                            "Third Party POA Details - ", poaFormData === null || poaFormData === void 0 ? void 0 :
                            poaFormData.acName,
                            ", Accode:", poaFormData === null || poaFormData === void 0 ? void 0 :
                            poaFormData.accode)))),
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "grid-container-4-68 pd-0-30 mt-30" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mgb-5" }, "Category"),
                        React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "", disabled: true, defaultValue: poaFormData === null || poaFormData === void 0 ? void 0 : poaFormData.companyName })),
                    React.createElement("div", null,
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Third Party Name:"),
                        React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", required: true, placeholder: "Enter Third Party Name", name: "thirdParty_Name", id: "thirdParty_Name", defaultValue: formData === null || formData === void 0 ? void 0 : formData.thirdParty_Name, onChangeEvent: function (e) {
                                return handleChange(e.target.name, e.target.value);
                            }, errorText: error === null || error === void 0 ? void 0 : error.thirdParty_NAME, onBlur: function (error) {
                                if (error.required)
                                    handleError("thirdParty_NAME", "This field is Required");
                                else
                                    handleError("thirdParty_NAME", "");
                            } })),
                    React.createElement("div", { className: " leadpage-selectdropdown" },
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Pan No"),
                        React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "Enter Pan No", name: "panNo", id: "panNo", pattern: pan, inputPattern: "^[a-zA-Z]{5}[\\d]{4}[a-zA-Z]{1}$", defaultValue: formData === null || formData === void 0 ? void 0 : formData.panNo, required: true, onChangeEvent: function (e) {
                                handleChange(e.target.name, e.target.value);
                            }, errorText: error === null || error === void 0 ? void 0 : error.panno, onBlur: function (error, event) {
                                if (error.required)
                                    handleError("panno", "This field is Required");
                                else if (!error.pattern &&
                                    !!event.target.value &&
                                    event.target.value.length > 0)
                                    handleError("panno", "This is Invalid Pan Number");
                                else
                                    handleError("panno", "");
                            } })),
                    React.createElement("div", { className: " leadpage-selectdropdown" },
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Email"),
                        React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "Enter Email", name: "email", id: "email", defaultValue: formData === null || formData === void 0 ? void 0 : formData.email, required: true, pattern: emailRegex, inputPattern: "^[-_a-zA-Z0-9]+(\\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*(\\.[a-zA-Z]{2,4})$", onChangeEvent: function (e) {
                                handleChange(e.target.name, e.target.value);
                            }, errorText: error === null || error === void 0 ? void 0 : error.email, onBlur: function (error, event) {
                                if (error.required) {
                                    handleError("email", "This field is Required");
                                }
                                else if (!error.pattern) {
                                    handleError("email", "Email id is invalid");
                                }
                                else
                                    handleError("email", "");
                            } })))),
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "grid-container-2-6-68 pd-0-30 mt-30" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey  mgb-5" }, "Mobile No"),
                        React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "Enter Mobile No", name: "mobileNo", id: "mobileNo", type: "text", pattern: phoneNo, maxLength: 10, defaultValue: formData === null || formData === void 0 ? void 0 : formData.mobileNo, required: true, onChangeEvent: function (e) {
                                handleChange(e.target.name, e.target.value);
                            }, errorText: error === null || error === void 0 ? void 0 : error.mobileNo, onBlur: function (error) {
                                var _a;
                                if (((_a = formData === null || formData === void 0 ? void 0 : formData.mobileNo) === null || _a === void 0 ? void 0 : _a.length) > 0 && !(error === null || error === void 0 ? void 0 : error.pattern)) {
                                    handleError("mobileNo", "Please enter valid mobile no");
                                }
                                else if (error.required)
                                    handleError("mobileNo", "This field is Required");
                                else
                                    handleError("mobileNo", "");
                            }, onKeyPress: function (keyEvent) {
                                if (keyEvent.key >= "0" && keyEvent.key <= "9") {
                                    return true;
                                }
                                else {
                                    if (keyEvent.key !== "Backspace" &&
                                        keyEvent.key !== "Enter")
                                        keyEvent.preventDefault();
                                }
                            } })),
                    React.createElement("div", null,
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey mgb-5" }, "Comments"),
                        React.createElement(InputField, { className: "RobotoM_16_500 txt_blackOne1", placeholderClassName: "", placeholder: "Enter Comments", name: "comments", id: "comments", defaultValue: formData === null || formData === void 0 ? void 0 : formData.comments, onChangeEvent: function (e) {
                                handleChange(e.target.name, e.target.value);
                            } })))),
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "pd-0-30 mt-30" },
                    React.createElement("table", { className: "table exchange-segment-table" },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Exchange Segment"),
                                React.createElement("th", null,
                                    React.createElement("div", { className: " flexCenter input-checkbox-row" },
                                        React.createElement("input", { type: "checkbox", name: "bseSegement", id: "bseSegement", checked: (formData === null || formData === void 0 ? void 0 : formData.eqbse.toLowerCase()) === "true" &&
                                                (formData === null || formData === void 0 ? void 0 : formData.fobse.toLowerCase()) === "true" &&
                                                (formData === null || formData === void 0 ? void 0 : formData.currencybse.toLowerCase()) === "true", onChange: function (e) {
                                                setFormData(function (formData) {
                                                    return __assign(__assign({}, formData), { eqbse: e.target.checked.toString(), fobse: e.target.checked.toString(), currencybse: e.target.checked.toString() });
                                                });
                                            }, className: "form-check-input common-checkbox" }),
                                        React.createElement("span", { className: "mgl-7" }, " BSE"))),
                                React.createElement("th", null,
                                    React.createElement("div", { className: "flexCenter input-checkbox-row" },
                                        React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", checked: (formData === null || formData === void 0 ? void 0 : formData.eqnse.toLowerCase()) === "true" &&
                                                (formData === null || formData === void 0 ? void 0 : formData.fonse.toLowerCase()) === "true" &&
                                                (formData === null || formData === void 0 ? void 0 : formData.currencynse.toLowerCase()) === "true", onChange: function (e) {
                                                setFormData(function (formData) {
                                                    return __assign(__assign({}, formData), { eqnse: e.target.checked.toString(), fonse: e.target.checked.toString(), currencynse: e.target.checked.toString() });
                                                });
                                            } }),
                                        React.createElement("span", { className: "mgl-7" }, "NSE"))),
                                React.createElement("th", null,
                                    React.createElement("div", { className: " flexCenter input-checkbox-row" },
                                        React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", checked: (formData === null || formData === void 0 ? void 0 : formData.eqmsei.toLowerCase()) === "true" &&
                                                (formData === null || formData === void 0 ? void 0 : formData.fomsei.toLowerCase()) === "true" &&
                                                (formData === null || formData === void 0 ? void 0 : formData.currencymsei.toLowerCase()) === "true", onChange: function (e) {
                                                setFormData(function (formData) {
                                                    return __assign(__assign({}, formData), { eqmsei: e.target.checked.toString(), fomsei: e.target.checked.toString(), currencymsei: e.target.checked.toString() });
                                                });
                                            } }),
                                        React.createElement("span", { className: "mgl-7" }, " MSEI"))))),
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", null, "Equity"),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_a = formData === null || formData === void 0 ? void 0 : formData.eqbse) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setFormData(__assign(__assign({}, formData), (_a = {}, _a["eqbse"] = e.target.checked.toString(), _a)));
                                        } })),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_b = formData === null || formData === void 0 ? void 0 : formData.eqnse) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setFormData(__assign(__assign({}, formData), (_a = {}, _a["eqnse"] = e.target.checked.toString(), _a)));
                                        } })),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_c = formData === null || formData === void 0 ? void 0 : formData.eqmsei) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setFormData(__assign(__assign({}, formData), (_a = {}, _a["eqmsei"] = e.target.checked.toString(), _a)));
                                        } }))),
                            React.createElement("tr", null,
                                React.createElement("td", null, "F/O"),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_d = formData === null || formData === void 0 ? void 0 : formData.fobse) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setFormData(__assign(__assign({}, formData), (_a = {}, _a["fobse"] = e.target.checked.toString(), _a)));
                                        } })),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_e = formData === null || formData === void 0 ? void 0 : formData.fonse) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setFormData(__assign(__assign({}, formData), (_a = {}, _a["fonse"] = e.target.checked.toString(), _a)));
                                        } })),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_f = formData === null || formData === void 0 ? void 0 : formData.fomsei) === null || _f === void 0 ? void 0 : _f.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setFormData(__assign(__assign({}, formData), (_a = {}, _a["fomsei"] = e.target.checked.toString(), _a)));
                                        } }))),
                            React.createElement("tr", null,
                                React.createElement("td", null, "Currency"),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_g = formData === null || formData === void 0 ? void 0 : formData.currencybse) === null || _g === void 0 ? void 0 : _g.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setFormData(__assign(__assign({}, formData), (_a = {}, _a["currencybse"] = e.target.checked.toString(), _a)));
                                        } })),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_h = formData === null || formData === void 0 ? void 0 : formData.currencynse) === null || _h === void 0 ? void 0 : _h.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setFormData(__assign(__assign({}, formData), (_a = {}, _a["currencynse"] = e.target.checked.toString(), _a)));
                                        } })),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", value: 1, checked: ((_j = formData === null || formData === void 0 ? void 0 : formData.currencymsei) === null || _j === void 0 ? void 0 : _j.toLowerCase()) === "true", onChange: function (e) {
                                            var _a;
                                            setFormData(__assign(__assign({}, formData), (_a = {}, _a["currencymsei"] = e.target.checked.toString(), _a)));
                                        } }))))))),
            React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "grid-container-1 pd-0-30 mt-30 consent-fileupload-section common-fileupload-section" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "d-feed-drag" },
                            React.createElement(FileUploadSection, { reset: resetFileUpload, disableCross: false, fileType: ["pdf", "jpg", "svg", "png"], 
                                // onSubmit={handleFileUpload}
                                onSubmit: function (fileinfo) {
                                    handleFileUpload(fileinfo);
                                }, fileSize: 8388608 }))))),
            editData && (React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "grid-container-1 pd-0-30 mt-30 " },
                    React.createElement("div", null,
                        React.createElement(EdButton, { type: "button", btnTyp: "midnight-blue-underline", value: "Downloads", onClick: function () {
                                downloadsClients(formData.poaFiles);
                            } }))))),
            React.createElement("div", { className: "mt-4 col-lg-6 offset-lg-3  justify-content-center" },
                React.createElement("div", { className: "btn-block-loa" },
                    React.createElement("div", { className: "px-0" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: editData ? "Update" : "Save", type: "button", disabled: disable, onClick: function () {
                                resetFileUpload
                                    ? saveThirdPartyPOADetails()
                                    : alert("Do you want to SAVE without uploading a the scanned POA?");
                                saveThirdPartyPOADetails();
                            } })),
                    React.createElement("div", { className: "px-0" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Reset", type: "button", onClick: function () {
                                setFormData(initialPoa);
                                setResetFileUpload(true);
                                setDeleteMsg("reset");
                            } })),
                    React.createElement("div", { className: "px-0" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Delete", type: "button", onClick: function () {
                                di.clients
                                    .deletePoaData({
                                    accode: poaFormData === null || poaFormData === void 0 ? void 0 : poaFormData.accode,
                                    acName: poaFormData === null || poaFormData === void 0 ? void 0 : poaFormData.acName,
                                    companyName: poaFormData === null || poaFormData === void 0 ? void 0 : poaFormData.companyName,
                                })
                                    .then(function (data) {
                                    var _a;
                                    setFormData(function (formData) {
                                        return __assign(__assign({}, formData), { thirdParty_Name: "", panNo: "", email: "", mobileNo: "", comments: "" });
                                    });
                                    setError(function (errorData) {
                                        errorData.thirdParty_NAME = "This field is required.";
                                        errorData.panno = "This field is required.";
                                        errorData.email = "This field is required.";
                                        errorData.mobileNo = "This field is required.";
                                        return errorData;
                                    });
                                    setDeleteMsg((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.strMsg);
                                })
                                    .catch(function (error) { return setDeleteMsg(error); });
                            } })))),
            React.createElement("div", { className: "d-flex align-item-center justify-content-center p-3 DMSans_16_500" }, deleteMsg ? (deleteMsg === "1" ? (React.createElement("span", { className: "text-success" }, "Data Deleted Sucessfully.")) : deleteMsg === "reset" ? (React.createElement("span", null)) : (React.createElement("span", { className: "text-danger" }, "Error in Deleting Data"))) : (React.createElement(React.Fragment, null, saveSuceMsg ? (React.createElement(React.Fragment, null,
                React.createElement("span", { className: saveThirdPartyError ? "text-danger" : "text-success" }, saveSuceMsg))) : ("")))))));
};
